
<section class="contact" #contact [class.animate]="animate">

</section>

<section class="info" [style.top]="((1 - offsetscroll) * 40) + 'rem'" *ngIf="seller">
    <div class="image">
        <img src="{{ seller.seller.image ? seller.seller.image : './assets/images/no-photo.jpg' }}" alt="{{ seller.seller.name }}">
    </div>
    <div class="left">
        <h3>{{ language == 'pt' ? 'Contactos' : 'Contacts' }}</h3>

        <div class="name">{{ seller.seller.name }}</div>
        <div class="phone">{{ language == 'pt' ? 'T' : 'P' }}: <a href="tel:{{ seller.seller.phone }}" target="_blank" rel="noopener">{{ seller.seller.phone }}</a></div>
        <div class="email">{{ language == 'pt' ? 'E' : 'E' }}: <a href="tel:{{ seller.seller.email }}" target="_blank" rel="noopener">{{ seller.seller.email }}</a></div>
    </div>
    <div class="right">
        <img src="{{ seller.company.image }}" alt="{{ seller.company.name }}">
    </div>
</section>

<section class="logos" id="logos">
    <div class="container d-flex align-top justify-center">
        <div class="third f-center">
            <h3 class="f-light f-upper">{{ language == 'pt' ? 'Arquitetura de Interiores' : 'Interior Design' }}</h3>
            <div class="items d-flex column align-center justify-center">
                <img src="assets/images/6xas.png" alt="6XAS">
                <div class="sep"></div>
                <h3 class="f-light f-upper">{{ language == 'pt' ? 'Apoio Técnico' : 'Technical Support' }}</h3>
                <img src="assets/images/cs.png" alt="CS">
            </div>
        </div>

        <div class="third f-center">
            <h3 class="f-light f-upper">{{ language == 'pt' ? 'Arquitetura' : 'Architecture' }}</h3>
            <div class="items d-flex align-center justify-center">
                <img src="assets/images/mcarq.png" alt="MC ARQ">
            </div>
        </div>

        <div class="half f-center">
            <h3 class="f-light f-upper">{{ language == 'pt' ? 'Promotores - Incorporadores' : 'Promoters - Developers' }}</h3>

            <div class="items d-flex align-center justify-center">
                <img src="assets/images/g5.png" alt="G%">
                <div class="sep grow"></div>
                <img src="assets/images/dona.png" alt="DONA">
                <div class="sep grow"></div>
                <img src="assets/images/leao.png" alt="Leão">
            </div>
        </div>
    </div>
</section>
